import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { resolveProductEntry, selectProductEntry } from '../services/productEntry';
import { useTenant } from '../contexts/TenantContext';
import { useLanguage } from '../i18n';
import { workspaceCopy } from '../workspaceCopy';

export default function ChooseWorkspace() {
  const { isAuthenticated } = useTenant();
  const { lang } = useLanguage(); const copy = workspaceCopy(lang);
  const [entry, setEntry] = useState(null); const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0); const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!isAuthenticated) return undefined;
    let active = true;
    resolveProductEntry().then(value => { if(active) setEntry(value); }).catch(() => { if(active) setError(copy.loadError); });
    return () => { active=false; };
  }, [isAuthenticated, attempt, copy.loadError]);
  const choose = async (product) => {
    setSaving(true); setError('');
    try { const value=await selectProductEntry(product); window.location.replace(value.product === 'ecommerce' ? value.entry_url : '/app/settings'); }
    catch (_) { setError(copy.saveError); setSaving(false); }
  };
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (entry && !entry.legacy) return <Navigate to="/app" replace />;
  return <Box as="main" p={8}><Heading size="lg">{lang==='zh' ? '继续使用原有工作台' : 'Continue to your existing workspace'}</Heading>
    <Text>{lang==='zh' ? '账号业务归属尚待管理员确认；此处仅保存原有入口偏好。' : 'Your administrator has not assigned this account yet. This only saves your existing entry preference.'}</Text>
    {error && <Text role="alert">{error}</Text>}
    {!entry && !error && <Text role="status">{copy.loading}</Text>}
    {!entry && error && <Button onClick={() => {setError('');setAttempt(v=>v+1);}}>{copy.retry}</Button>}
    {entry?.legacy && <><Button isDisabled={saving} onClick={()=>choose('front_desk')}>{copy.frontDesk}</Button><Button isDisabled={saving} onClick={()=>choose('ecommerce')}>{copy.ecommerce}</Button></>}
  </Box>;
}
